module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_implant-4ab2a4578535996a6fe60592ff950d7a.png";